import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  // Enables the i18next backend
  .use(Backend)
  // Enable automatic language detection
  .use(LanguageDetector)
  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    supportedLngs: ['ua'],
    fallbackLng: 'ua',
    detection: {
      lookupQuerystring: 'lang',
      order: ['querystring', 'cookie', 'localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
